import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DocumentDuplicateCheckService {
  private documentHashes: { hash: string; pageName?: string }[] = [];

  populateDocumentHashValues(documentHashes: { hash: string; pageName?: string }[]): void {
    if (!Array.isArray(documentHashes)) {
      this.documentHashes = [];
    } else {
      this.documentHashes = documentHashes.map((doc) => ({
        hash: doc.hash,
        pageName: doc.pageName,
      }));
    }
  }
  updateDocumentHashList(hash: { hash: string; pageName: string }) {
    this.documentHashes.push(hash);
  }
  deleteFromDocumentHashList(hash: string) {
    this.documentHashes = this.documentHashes.filter((doc) => doc.hash !== hash);
  }
  findDuplicateDoc(hash: string) {
    return this.documentHashes.find((item) => item.hash == hash);
  }
}
